import { patchState, signalStore, withHooks, withMethods, withState } from "@ngrx/signals";
import { setFulfilled, setPending, withRequestStatus } from "../extensions/request-status.feature";
import { inject } from "@angular/core";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { pipe, switchMap, tap } from "rxjs";
import { ApiServerConfigsService, ServerConfigBackOfficeViewModel } from "../../services/api-serverConfigs.service";

export type ServerConfigsStore = InstanceType<typeof ServerConfigsStore>;

export const ServerConfigsStore = signalStore(
    { providedIn: "root", protectedState: false },
    withState({
        config: undefined as ServerConfigBackOfficeViewModel | undefined,
    }),
    withRequestStatus(),
    withMethods((store, apiServerConfigsService = inject(ApiServerConfigsService)) => ({
        loadConfigs: rxMethod<void>(
            pipe(
                tap(() => patchState(store, setPending())),
                switchMap(() => {
                    return apiServerConfigsService.getServerConfigs().pipe(
                        tap((config) => {
                            patchState(store, { config });
                            patchState(store, setFulfilled());
                        }),
                    );
                }),
            ),
        ),
    })),
    withHooks((store) => ({
        onInit: () => {
            store.loadConfigs();
        },
    })),
);
